/**
 * What the mission page (/mission, alias /about/mission/project-mission) tells search engines and link previews — ONE
 * copy, read by today's page (src/pages/Mission.tsx) and its rebuild in the new design, the way src/config/startSeo.ts
 * serves both start pages (design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/mission"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so each
 * stays one line.
 */
export const MISSION_SEO = {
  title: 'Our Mission | prest0',
  tabTitle: 'mission',
  description: "prest0's mission: expand what law and finance teams can deliver — 24/7 AI employees that research, draft, coordinate, and execute so experts focus on judgment.",
  keywords: 'prest0 mission, AI employees, law finance, AI for law firms, finance AI, digital employees, specialist capacity, expert leverage',
  canonicalUrl: 'https://prest0.ai/mission',
} as const;
